import React from "react";

const Step8 = ({ setCurrStep }) => {
  return (
    <div className="d-flex flex-column" style={{ flex: 1 }}>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ border: "solid 2px #6200ff", flex: 1 }}
      >
        <h1>Form has been submitted</h1>
      </div>
    </div>
  );
};

export default Step8;
